module.exports = __webpack_public_path__ + "img/UpperPieceMoveS1Page.69e72462.png";